import { Link } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { ArrowLeft, Download } from "lucide-react";

export default function Qris() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="qris-page">
      <header className="border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-xl items-center gap-3 px-4 py-3">
          <Link to="/"><img src="/logo-lazisnu.png" alt="Logo LAZISNU Dawe" className="h-10 w-10 rounded-lg bg-white object-contain p-0.5" /></Link>
          <div className="flex-1">
            <p className="font-heading font-bold text-slate-900 leading-tight">QRIS Infaq / Sedekah</p>
            <p className="text-xs text-slate-500">UPZIS LAZISNU Dawe</p>
          </div>
          <Link to="/">
            <Button variant="outline" size="sm" data-testid="qris-back-button">
              <ArrowLeft className="mr-1.5 h-4 w-4" /> Kembali
            </Button>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-xl px-4 py-8">
        <Card>
          <CardContent className="p-6 text-center">
            <p className="text-sm text-slate-500 mb-4">
              Pindai kode QR berikut dengan aplikasi pembayaran apa pun (berlogo QRIS) untuk berinfaq/bersedekah
            </p>
            <img
              src="/qris-lazisnu-dawe.jpg"
              alt="QRIS UPZIS LAZISNU Dawe"
              className="mx-auto w-full max-w-md rounded-xl border border-slate-200 shadow-sm"
              data-testid="qris-image"
            />
            <a href="/qris-lazisnu-dawe.jpg" download="QRIS-UPZIS-LAZISNU-Dawe.jpg">
              <Button variant="outline" className="mt-4" data-testid="qris-download-button">
                <Download className="mr-2 h-4 w-4" /> Unduh QRIS
              </Button>
            </a>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
